import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, type TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge/BetaBadge';

interface Props {}

const VideoCreatorListItem: FC<Props> = () => {
  const { t } = useTranslation();

  const href = Url.videoCreatorLink();

  return (
    <ListItemLink
      label={t('dreamup.siteHeader.links.video')}
      href={href}
      biData={BiData<TopNavClickBiEvent>({
        evid: 700,
        link_name: t('dreamup.siteHeader.links.video'),
        link_url: href,
      })}
      suffix={<BetaBadge badgeType="new" size="medium" variant="purple" />}
    />
  );
};

VideoCreatorListItem.displayName = 'VideoCreatorListItem';
export default VideoCreatorListItem;
